import apiClient from '@u/apiClient'
import QuestionActions from './question/actions'
import GetSurveyListController from '@/wayfinder/actions/App/Http/Controllers/Survey/GetSurveyListController'
import GetSurveyByIdController from '@/wayfinder/actions/App/Http/Controllers/Survey/GetSurveyByIdController'
import CreateSurveyController from '@/wayfinder/actions/App/Http/Controllers/Survey/CreateSurveyController'
import UpdateSurveyController from '@/wayfinder/actions/App/Http/Controllers/Survey/UpdateSurveyController'
import DeleteSurveyController from '@/wayfinder/actions/App/Http/Controllers/Survey/DeleteSurveyController'
import GetNewModelController from '@/wayfinder/actions/App/Http/Controllers/NewModel/GetNewModelController'

const baseErrors = {}

function processSuccessCallback(payload) {
  if (payload.successCallback) {
    if ('new_id' in payload) {
      payload.successCallback(payload.new_id)
    } else {
      payload.successCallback()
    }
  }
}

export default {
  ...QuestionActions,
  // region fetch

  fetchSurveyList({ commit }, payload) {
    commit('auth/setErrors', baseErrors, { root: true })
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetSurveyListController.get())
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  fetchNewSurvey({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetNewModelController.get({ query: { model: 'survey' } }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchSurveyById({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetSurveyByIdController.get({ survey: payload.id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region store
  storeNewSurvey: ({ commit }, payload) => {
    commit('auth/setErrors', baseErrors, { root: true })
    return new Promise((resolve, reject) => {
      apiClient
        .route(CreateSurveyController.post(), payload.survey)
        .then(async (response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region update
  updateSurvey: ({ commit }, payload) => {
    commit('auth/setErrors', baseErrors, { root: true })
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateSurveyController.put({ survey: payload.id }),
          payload.survey
        )
        .then(async (response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region delete
  deleteSurveyById: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(DeleteSurveyController.delete.delete({ survey: payload.id }))
        .then(async (response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  undoDeleteSurveyById: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(DeleteSurveyController.undo.get({ id: payload.id }))
        .then(async (response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  setDataTransferObject({ commit }, payload) {
    commit('setDataTransferObject', payload)
  },
  setDataSectionObject({ commit }, payload) {
    commit('setDataSectionObject', payload)
  }
}
